module.exports = __webpack_public_path__ + "static/media/volume.69c36a8f.png";